export default "__VITE_ASSET__BIYe_5F6__"